import { Reflector } from "three/addons/objects/Reflector.js";
import MainExperience from "../MainExperience/MainExperience";
import { PlaneGeometry } from "three";
import vertexShader from "../../shaders/water/vertex.glsl";
import fragmentShader from "../../shaders/water/fragment.glsl";
import { RepeatWrapping } from "three";

export default class Water {
  constructor() {
    this.experience = new MainExperience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    this.createWater();

    // Event handlers
    this.time.on("tick", () => {
      this.update();
    });
  }

  createWater = () => {
    this.geometry = new PlaneGeometry(500, 500);

    this.customShader = Reflector.ReflectorShader;
    this.customShader.vertexShader = vertexShader;
    this.customShader.fragmentShader = fragmentShader;

    const dudvMap = this.resources.items.waterdudv;
    dudvMap.wrapS = dudvMap.wrapT = RepeatWrapping;
    this.customShader.uniforms.tDudv = { value: dudvMap };
    this.customShader.uniforms.waveStrength = { value: 0.08 }; // wave strenght
    this.customShader.uniforms.time = { value: 0 }; // increasing time value
    this.customShader.uniforms.transmission = { value: 0.6 }; // reflection
    this.customShader.uniforms.waveSpeed = { value: 2.5 / 1000 }; // wavespeed

    this.reflector = new Reflector(this.geometry, {
      clipBias: 0.1,
      textureWidth: window.innerWidth,
      textureHeight: window.innerHeight,
      shader: this.customShader,
      color: 0x01002e,
    });

    this.reflector.position.y = 0.001;
    this.reflector.rotateX(-Math.PI / 2);
    this.scene.add(this.reflector);
  };

  update() {
    if (this.reflector.material.uniforms) {
      this.reflector.material.uniforms.time.value += 1;
    }
  }
}
